import axios from 'axios'

const { VUE_APP_API_SERVER, VUE_APP_AMEX } = process.env


const fetchQuote = (quote) => {
  return axios
    .post(`${VUE_APP_API_SERVER}/insurance/quote`, quote)
    .then((res) => {
      if (res && res.data) {
        return res.data;
      }
    })  
    .catch(() => {
      return { premium: undefined, error: true };
    });
};


const payment = (finalQuote) => {
  const result = { error: false }
  return axios
    .post(`${VUE_APP_API_SERVER}/insurance/payment`, finalQuote)
    .then((res) => {
      if (res && res.data) {
        result.data = res.data
        return result.data
      }
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const getCountries = () => {
  const result = { error: false }
  return axios
    .get(`${VUE_APP_API_SERVER}/mysqlcountries`)
    .then((res) => {
      if (res && res.data) {
        result.data = res.data
        return result.data
      }
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const logSubmit = (info) => {
  const result = { error: false }
  return axios
    .post(`${VUE_APP_API_SERVER}/insurance/log`, info)
    .then((res) => {
      if (res && res.data) {
        result.data = res.data
        return result
      }
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const postHelpForm = (data) => {
  const options = {
    headers: { 'cache-control': 'no-cache' }
  }
  const result = { error: false }
  return axios
    .post(`${VUE_APP_API_SERVER}/email/`, data, options)
    .then((res) => {
      if (res && res.data) {
        result.data = res.data
        return result
      }
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const getAddressInfo = (postcode) => {
  const result = { error: false }
  return axios
    .get(`${VUE_APP_API_SERVER}/address/${postcode}`)
    .then((res) => {
      return res.data.results
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const getFullAddressInfo = (url) => {
  const result = { error: false }
  return axios
    .get(url)
    .then((res) => {
      return res.data.address
    })
    .catch(() => {
      result.error = true
      return result
    })
}

const amexButtonPayment = async (booking) => {
  let url
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
    url = `https://test.trailfinders.com/insurance#`
  } else {
    url = `https://www.trailfinders.com/insurance#`
  }
  try {
    window.$pwb.openWindow()
    // send payment confirmation before payments
    // orderId added serverside
    const res = await axios
      .post(`${VUE_APP_AMEX}/button`, {
        tfSystem: 'insurance',
        customerId: booking.customerId,
        redirect: `${url}/amex/${booking.customerId}`,
        amount: booking.purchaseAmount,
        currency: booking.currencyCode,
        address1: booking.billingAddressLine1,
        address2: booking.billingAddressLine2,
        address3: booking.billingAddressLine3,
        postcode: booking.billingAddressPostcode,
        email: booking.email,
        phone: booking.phone,
        name: booking.name,
        title: booking.title,
        firstname: booking.firstname,
        surname: booking.surname,
        logname: '',
        staffid: '',
        insuranceData: booking.insuranceData,
        adults: booking.adults,
        children: booking.children,
        coverType: booking.coverType,
        cruise: booking.cruise,
        dateFrom: booking.dateFrom,
        dateTo: booking.dateTo,
        depDate: booking.depDate,
        destination: booking.destination,
        duration: booking.duration,
        familyDiscount: booking.familyDiscount,
        infants: booking.infants,
        option: booking.option,
        paySource: booking.paySource,
        winterSport: booking.winterSport,
      })
    if (res && res.data) {


      if (res.data.status === 'REQUOTE') {
        window.$pwb.updateInit(false)

      } else {
        window.$pwb.updateInit(res.data)

      }
      return res.data
    }
  } catch {
    window.$pwb.updateInit(false)
    return null
  }
}

const amexUpdate = async (payload) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_AMEX}/gccallback`

    const res = await axios.post(url, payload)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  fetchQuote,
  payment,
  getCountries,
  logSubmit,
  postHelpForm,
  getAddressInfo,
  getFullAddressInfo,
  amexButtonPayment,
  amexUpdate
}
